// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"78":"9acfeefb","245":"0aecd212","976":"5b852b8f"}[chunkId] + ".chunk.js";
};